/**
 *	Loops through product cards to find the tallest card.
 *	All other product cards are then resized to match the tallests cards height.
 *
 *	Kevin Granlund 03-07-2018
 *
 */
equalheight = function(container){
    var cards = jQuery(container).find('.card');
    var tallest_height = 0;
    jQuery.each(cards, function(index, element) {
        var height = jQuery(element).height();
        if(height > tallest_height) {
            tallest_height = height;
            jQuery(element).height(tallest_height);
        }
    });
    jQuery.each(cards, function(index, element) {
        var height = jQuery(element).height();
        if(height != tallest_height) {
            jQuery(element).height(tallest_height);
        }
    });
}


/*jQuery(window).load(function() {
  equalheight('.collection-template .grid');
});


jQuery(window).resize(function(){
  equalheight('.collection-template .grid');
});*/

window.onload = function() {
  equalheight('.collection-template .grid');
};